import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { routes } from 'config';
import { Page } from 'styles';
import { BackLink } from 'components/back-link';
import { LoadingPage } from 'components/loading';
import { ErrorPage } from 'components/errors';
import { getTermsUrl } from 'components/modals/vnm-terms/term-link/term-link.utils';
import { ScrollablePdf } from './scrollable-pdf.component';

export const FETCH_PERSONALIZED_CONTRACT = gql`
  query Lovebird_FetchPersonalizedContract(
    $contractVersionId: Int!
    $utilityAccountId: Int!
  ) {
    contractVersion(id: $contractVersionId) {
      id
      personalizedFile(utilityAccountId: $utilityAccountId)
    }
  }
`;

const { contracts } = routes();

export const PersonalizedContract = ({ match }) => {
  const contractVersionId = Number(match.params.contractVersionId);
  const utilityAccountId = Number(match.params.utilityAccountId);

  const { data, loading, error } = useQuery<
    // eslint-disable-next-line camelcase
    Lovebird_FetchPersonalizedContractQuery,
    // eslint-disable-next-line camelcase
    Lovebird_FetchPersonalizedContractQueryVariables
  >(FETCH_PERSONALIZED_CONTRACT, {
    variables: { contractVersionId, utilityAccountId },
  });

  const catbirdLink = getTermsUrl({
    id: contractVersionId,
  });

  if (loading || !data) return <LoadingPage />;
  if (data && !data.contractVersion?.personalizedFile)
    window.location.href = catbirdLink;
  if (error) return <ErrorPage to={contracts} />;

  return (
    <>
      <BackLink to={contracts} />
      <Page maxWidth="100%">
        {/* @ts-expect-error Type 'string | null' is not assignable to type 'string'. Null case handled above */}
        <ScrollablePdf pdfUrl={data.contractVersion.personalizedFile} />
      </Page>
    </>
  );
};
